export class ForgotPasswordFakeDb {
  public static users = [];
}
